import React from "react";
import { Typography, Button, Popconfirm, Progress, Tag } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import { chargingStatus, CHARGING_STATUS_COLORS } from "../utilities/helper";
import Can from "../components/Can";
import CopyText from "../components/CopyText";
import { PERMISSIONS } from "./permissions";

const { Text } = Typography;

const batteryColor = (value) => {
  if (value < 20) return "#dc2626";
  if (value < 50) return "#f59e0b";
  return "#16a34a";
};

export const overviewTable = (deviceType, sno, handleEject) => {
  const columns = [
    {
      title: "Sr. No.",
      key: "serial_no",
      className: "col-index",
      width: 80,
      responsive: ["sm"],
      render: (item, record, index) => <Text>{index + 1}</Text>,
    },
    {
      title: "Battery Id",
      key: "battery_id",
      dataIndex: "dno",
      className: "col-mono",
      render: (item) => <CopyText value={item} />,
    },
    {
      title: "Charging Status",
      key: "charging_status",
      dataIndex: "charging_status",
      render: (item, record) =>
        chargingStatus[item] ? (
          <Tag color={CHARGING_STATUS_COLORS[item] || "default"}>
            {chargingStatus[item]}
          </Tag>
        ) : (
          <Text>{chargingStatus[item]}</Text>
        ),
    },
    {
      title: "Battery Percentage",
      key: "percentage",
      dataIndex: "status",
      render: (item) => {
        const value = Number(item);

        if (item === null || item === undefined || item === "" || Number.isNaN(value)) {
          return <Text>{item}%</Text>;
        }

        return (
          <div className="battery-level">
            <Progress
              percent={value}
              size="small"
              showInfo={false}
              strokeColor={batteryColor(value)}
            />
            <Text className="battery-level__value">{item}%</Text>
          </div>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      align: "right",
      className: "col-actions",
      fixed: "right",
      render: (item, record) =>
        record.dno !== null ? (
          <Can permissions={[PERMISSIONS.EJECT_BATTERY]}>
            <Popconfirm
              title="Eject this battery?"
              description={`Battery ${record.dno} will be released from the cabinet.`}
              okText="Eject"
              okButtonProps={{ danger: true }}
              cancelText="Cancel"
              placement="left"
              onConfirm={() => handleEject(record.dno, sno)}
            >
              <Button danger type="primary" icon={<ExportOutlined />}>
                Eject
              </Button>
            </Popconfirm>
          </Can>
        ) : null,
    },
  ];

  return columns;
};
